export default "<video class=\"video-container\" controls [src]=\"videoUrl\"></video>"